/***
 * ZDE BY MELI BYT DEKLAROVANY VESKERE KLICE PRO STRANKY
 * TYTO KLICE SLOUZI K OZNACENI AKTUALNI STRANKY V MENU
 */
export const MAPA_PAGE_KEY = 'MAPA_PAGE_KEY';
export const DAVKA_DTM_PAGE_KEY = 'DAVKA_DTM_PAGE_KEY';
